"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

require("./Style.css");

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactSlick = require("react-slick");

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _idbReactIconlib = require("@identitybuilding/idb-react-iconlib");

var _idbReactIconlib2 = _interopRequireDefault(_idbReactIconlib);

var _SocialInsta = require("./components/SocialInsta");

var _SocialInsta2 = _interopRequireDefault(_SocialInsta);

var _SocialFacebook = require("./components/SocialFacebook");

var _SocialFacebook2 = _interopRequireDefault(_SocialFacebook);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var SocialNews = function SocialNews(props) {
  var mobile = require("is-mobile");

  var _useState = (0, _react.useState)(props.isLoaded),
      _useState2 = _slicedToArray(_useState, 2),
      isLoaded = _useState2[0],
      setIsLoaded = _useState2[1];

  var _useState3 = (0, _react.useState)("facebook"),
      _useState4 = _slicedToArray(_useState3, 2),
      isTab = _useState4[0],
      setIsTab = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      isDataInsta = _useState6[0],
      setIsDataInsta = _useState6[1];

  var _useState7 = (0, _react.useState)([]),
      _useState8 = _slicedToArray(_useState7, 2),
      isDataFace = _useState8[0],
      setIsDataFace = _useState8[1];

  var _useState9 = (0, _react.useState)([]),
      _useState10 = _slicedToArray(_useState9, 2),
      isProfileData = _useState10[0],
      setIsProfileData = _useState10[1];

  var graphUrl = "https://graph.facebook.com/";

  var Arrow = function Arrow(props) {
    var className = props.className,
        onClick = props.onClick,
        dir = props.dir;

    return _react2.default.createElement(_idbReactIconlib2.default, {
      className: className,
      name: dir === "next" ? "ArrowRight" : "ArrowLeft",
      onClick: onClick
    });
  };

  var slider = {
    nextArrow: _react2.default.createElement(Arrow, { dir: "next" }),
    prevArrow: _react2.default.createElement(Arrow, { dir: "prev" }),
    className: "center",
    dots: true,
    infinite: true,
    speed: 500,
    slidestoshow: 3,
    arrows: true,
    variableWidth: true,
    centerMode: true,
    rows: 1,
    autoplay: true,
    swipeToSlide: false,
    draggable: false
  };

  var setFirstTab = function setFirstTab() {
    if (props.facebookId) {
      setIsTab("facebook");
    } else {
      setIsTab("instagram");
    }
  };

  var getInstaData = function getInstaData() {
    _axios2.default.get(graphUrl + (props.instaId + "/media?fields=comments{text,username,like_count},caption,like_count,media_url,username,timestamp,id,media_type,comments_count,thumbnail_url,permalink,children{media_url}&limit=10&access_token=" + props.token)).then(function (res) {
      isDataInsta.push.apply(isDataInsta, _toConsumableArray(res.data.data));

      isDataInsta.sort(function (a, b) {
        return a.created_time > b.created_time ? -1 : a.created_time < b.created_time ? 1 : 0;
      });
      setIsLoaded(true);
    });
  };
  var getFacebookData = function getFacebookData() {
    _axios2.default.get(graphUrl + (props.facebookId + "/posts?fields=full_picture,story,id,message,created_time,status_type,from{name,picture},attachments{media,subattachments}&limit=10&access_token=" + props.token)).then(function (res) {
      for (var i = 0; i < res.data.data.length; i++) {
        if (!isDataFace.includes(res.data.data[i].id, 0) && res.data.data[i].status_type !== "shared_story") {
          isDataFace.push(res.data.data[i]);
        }
      }

      isDataFace.sort(function (a, b) {
        return a.created_time > b.created_time ? -1 : a.created_time < b.created_time ? 1 : 0;
      });
      removeBadPosts();
    });
  };

  var removeBadPosts = function removeBadPosts() {
    for (var i = 0; i < isDataFace.length; i++) {
      if (isDataFace[i].message === undefined && isDataFace[i].story === undefined && isDataFace[i].description === undefined) {
        isDataFace.splice(i, 1);
      }
    }
    setIsLoaded(true);
  };

  var changeTabFace = function changeTabFace() {
    setIsTab("facebook");
    setIsLoaded(true);
  };
  var changeTabInsta = function changeTabInsta() {
    setIsTab("instagram");
    setIsLoaded(true);
  };

  (0, _react.useEffect)(function () {
    setFirstTab();
    if (props.facebookId) {
      getFacebookData();
    }
    if (props.instaId) {
      getInstaData();
    }
  }, [isDataFace, isDataInsta]);

  return _react2.default.createElement(
    _react.Fragment,
    null,
    isLoaded && _react2.default.createElement(
      "section",
      {
        id: "social",
        className: [!props.template ? "temp-1" : "temp-" + props.template, !props.theme ? "light" : props.theme, mobile() === true ? "mobile" : ""].join(" ")
      },
      _react2.default.createElement(
        "h2",
        {
          className: [props.facebookId && props.instaId ? "multiple" : "single", "social-title"].join(" ")
        },
        props.title
      ),
      _react2.default.createElement(
        "div",
        {
          className: [props.facebookId && props.instaId ? "multiple" : "single", "tab-container"].join(" ")
        },
        props.facebookId && _react2.default.createElement(
          "button",
          {
            className: [isTab === "facebook" ? "active" : "", "face tab"].join(" "),
            onClick: changeTabFace
          },
          "Facebook"
        ),
        props.instaId && _react2.default.createElement(
          "button",
          {
            className: [isTab === "instagram" ? "active" : "", "insta tab"].join(" "),
            onClick: changeTabInsta
          },
          "Instagram"
        )
      ),
      isTab === "instagram" && _react2.default.createElement(
        "div",
        { id: "feed-insta" },
        _react2.default.createElement(
          "div",
          { className: "feed-data" },
          _react2.default.createElement(
            _reactSlick2.default,
            slider,
            isDataInsta.map(function (post) {
              return _react2.default.createElement(_SocialInsta2.default, {
                post: post,
                key: post.id,
                defaultImage: props.defaultImage
              });
            })
          )
        )
      ),
      isTab === "facebook" && _react2.default.createElement(
        "div",
        { id: "feed-face" },
        _react2.default.createElement(
          "div",
          { className: "feed-data" },
          _react2.default.createElement(
            _reactSlick2.default,
            slider,
            isDataFace.map(function (post) {
              return _react2.default.createElement(_SocialFacebook2.default, {
                post: post,
                key: post.id,
                defaultImage: props.defaultImage
              });
            })
          )
        )
      )
    )
  );
};

exports.default = SocialNews;